/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomer200ResponseCustomerAddressesInner
 */
export interface GetCustomer200ResponseCustomerAddressesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    postalCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    selected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomer200ResponseCustomerAddressesInner
     */
    longitude?: string;
}

/**
 * Check if a given object implements the GetCustomer200ResponseCustomerAddressesInner interface.
 */
export function instanceOfGetCustomer200ResponseCustomerAddressesInner(value: object): value is GetCustomer200ResponseCustomerAddressesInner {
    return true;
}

export function GetCustomer200ResponseCustomerAddressesInnerFromJSON(json: any): GetCustomer200ResponseCustomerAddressesInner {
    return GetCustomer200ResponseCustomerAddressesInnerFromJSONTyped(json, false);
}

export function GetCustomer200ResponseCustomerAddressesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomer200ResponseCustomerAddressesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'address': json['address'] == null ? undefined : json['address'],
        'details': json['details'] == null ? undefined : json['details'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'selected': json['selected'] == null ? undefined : json['selected'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

export function GetCustomer200ResponseCustomerAddressesInnerToJSON(json: any): GetCustomer200ResponseCustomerAddressesInner {
    return GetCustomer200ResponseCustomerAddressesInnerToJSONTyped(json, false);
}

export function GetCustomer200ResponseCustomerAddressesInnerToJSONTyped(value?: GetCustomer200ResponseCustomerAddressesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'address': value['address'],
        'details': value['details'],
        'postalCode': value['postalCode'],
        'selected': value['selected'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

